import React, { useState } from 'react';
import { Clock, Calendar as CalendarIcon } from 'lucide-react';
import ScheduleManager from './ScheduleManager';
import ShiftManager from './ShiftManager';

export default function ShiftManagementModule() {
  const [activeTab, setActiveTab] = useState('schedules');

  return (
    <div className="space-y-5">
      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit">
        <button
          onClick={() => setActiveTab('schedules')}
          className={`flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-medium transition-all ${
            activeTab === 'schedules'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <Clock size={15} />
          Horarios
        </button>
        <button
          onClick={() => setActiveTab('shifts')}
          className={`flex items-center gap-2 px-5 py-2 rounded-lg text-sm font-medium transition-all ${
            activeTab === 'shifts'
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <CalendarIcon size={15} />
          Turnos
        </button>
      </div>

      {/* Content */}
      {activeTab === 'schedules' && <ScheduleManager />}
      {activeTab === 'shifts' && <ShiftManager />}
    </div>
  );
}
